module.exports = __webpack_public_path__ + "img/photoAlbum2.0ba229bc.jpg";